import { defineStore } from "pinia";
import api from "@/api/axios";

export const useAuthStore = defineStore({
    id: "auth",
    state: () => ({
        user: JSON.parse(localStorage.getItem("user") as string) || null, // Load user from localStorage
        token: localStorage.getItem("token") || null, // Load token from localStorage
    }),
    actions: {
        setUser(user: any) {
            this.user = user;
            localStorage.setItem("user", JSON.stringify(user)); // Persist user data in localStorage
        },

        setToken(token: string) {
            this.token = token;
            localStorage.setItem("token", token); // Persist token in localStorage
            api.defaults.headers.common["Authorization"] = `Bearer ${token}`; // Set token in axios headers
        },

        async getUser() {
            if (!this.token) return;
            try {
                const response = await api.get("/auth/user", {
                    headers: { Authorization: `Bearer ${this.token}` },
                });
                console.log('init')
                console.log(this.user)
                this.user = response.data;
            } catch (error) {
                console.error("Fetch user error", error);
            }
        },
    },
});
